import {
  Center,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'
import React from 'react'

import { GenericModalFooter } from '~shared-components/components/Modal/GenericModalFooter'
import { ModalCloseButton } from '~shared-components/components/Modal/ModalCloseButton'
import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconEnterprise } from '~shared-components/icons/brand/IconEnterprise'

import { LeadText } from '../Typography/Typography'

interface ChangeSalesOrgModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ChangeSalesOrgModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ChangeSalesOrgModalProps) => {
  const t = useTranslations()

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset="scale"
      onClose={onClose}
      size="2xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading
            color="deepPurple"
            size="xl"
            textAlign="left"
            textTransform="capitalize"
          >
            {t('label.changesalesorg')}
          </Heading>
        </ModalHeader>
        <ModalCloseButton aria-label="close" onClose={onClose} />
        <ModalBody>
          <VStack alignItems="flex-start" spacing={5} w="100%">
            <Heading color="neutral.90" size="lg" textAlign="left">
              {t('label.changesalesorgwarning')}
            </Heading>
            <Center w="100%">
              <IconEnterprise boxSize={100} color="neutral.50" />
            </Center>
            <LeadText>{t('message.changesalesorg')}</LeadText>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <GenericModalFooter
            actionButtonId="modal-change-sales-org-btn"
            actionIcon="IconCheckmark"
            actionTextLabel="label.button.changesalesorg"
            onAction={onConfirm}
            onCancel={onClose}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
